<template lang="pug">
v-list
  .d-flex.mb-3.align-center
    .text-body-1: strong Политика и положение
    //- v-btn.ml-auto(fab small depressed color="primary")
    //-   v-icon mdi-plus
  v-list-item.sdo-radius.mb-1(
    v-for="(item, idx) in list" :key="item.id"
    @click="routeTo(item.id)"
  )
    v-list-item-content
      v-window(:value="Number(editItem === item.id)")
        v-window-item
          //- v-icon.mr-4(
          //-   size="40"
          //-   :color="item.is_active ? 'success' : 'grey'"
          //- ) {{item.is_active ? 'mdi-check-circle-outline' : 'mdi-close-circle-outline'}}
          .text-body-2: strong {{ item.title }}
          v-chip(small :color="item.is_active ? 'success' : 'grey lighten-1'")
            v-icon(
              small
              left
              ) {{item.is_active ? 'mdi-check-circle-outline' : 'mdi-close-circle-outline'}}
            span {{item.is_active ? 'Активно' : 'Не активно'}}

        v-window-item
          .d-flex
            v-btn.mt-3.mr-2(
              color="error"
              icon
              @click.stop="editItem = null; editTitle = null"
            ): v-icon mdi-close
            v-text-field(
              v-model="editTitle"
              label="Введите название"
              rounded filled
              hide-details
              @click.stop
            )
            v-btn.mt-2.ml-2(
              color="success"
              fab depressed small
              :loading="loading.editName"
              @click.stop="editDocumentName(item.id, idx)"
            ): v-icon mdi-plus

    v-list-item-action(v-if="editItem !== item.id").ma-0
      v-menu
        template(#activator="{ on }")
          v-btn(v-on="on" color="primary" fab text): v-icon mdi-menu
        v-list
          v-list-item(@click="handleActivateDocument(item.is_active, item.id, idx)")
            v-list-item-icon.mr-2: v-icon(
              :color="item.is_active ? null : 'success' "
            ) mdi-check
            v-list-item-title(:class="item.is_active ? null : 'success--text'")
              strong {{ item.is_active ? 'Деактивировать' : 'Активировать'}}
          template(v-if="!item.is_main_policy")
            v-list-item(
              @click="editItem = item.id; editTitle = item.title"
            )
              v-list-item-icon.mr-2: v-icon(color="primary") mdi-pencil
              v-list-item-title.primary--text: strong Редактировать
            v-list-item(@click="deleteDocument(item.id, idx)")
              v-list-item-icon.mr-2: v-icon(color="error") mdi-delete
              v-list-item-title.error--text: strong Удалить

  v-window.overflow-visible(v-model="stepAdd")
    v-window-item
      v-list-item.sdo-radius.py-2(
        @click="stepAdd = Number(!stepAdd)"
      )
        v-list-item-icon: v-icon(color="success") mdi-plus-thick
        v-list-item-content: strong Добавить документ
    v-window-item
      v-list-item.sdo-radius.py-2
        v-list-item-action
          v-btn(
            color="error"
            icon depressed
            @click="stepAdd = Number(!stepAdd)"
          ): v-icon mdi-close
        v-text-field(
          v-model="documentName"
          label="Введите название документа"
          hide-details
          rounded filled
        )
        v-list-item-action
          v-btn(
            color="success"
            :disabled="!documentName"
            fab depressed small
            @click="addDocument"
          ): v-icon mdi-plus

</template>
<script>

export default {
  data() {
    return {
      stepAdd: 0,
      list: [],
      documentName: null,
      editItem: null,
      editTitle: null,
      loading: {
        editName: false,
      },
    };
  },
  created() {
    this.init();
  },
  methods: {
    routeTo(id) {
      this.$router.push({ name: 'ConstructorDocument', params: { id } });
    },
    init() {
      const params = {
        'search[organization_id]': this.$user.organization.id,
      };
      this.$api.contracts.getAgreements(params).then(({ data }) => {
        this.list = data.data;
      });
    },
    async addDocument() {
      const payload = {
        organization_id: this.$user.organization.id,
        title: this.documentName,
      };
      const { data } = await this.$api.contracts.createAgreement(payload);
      this.list.push(data.data);
      this.stepAdd = 0;
    },
    async editDocumentName(id, idx) {
      this.loading.editName = true;
      const payload = {
        title: this.editTitle,
      };
      await this.$api.contracts.saveAgreement(id, payload).then(() => {
        this.list[idx].title = this.editTitle;
        this.editTitle = null;
        this.editItem = null;
      });
      this.loading.editName = false;
    },
    async handleActivateDocument(isActive, id, idx) {
      const payload = {
        is_active: !isActive,
      };
      await this.$api.contracts.saveAgreement(id, payload).then(() => {
        this.list[idx].is_active = !isActive;
      });
    },
    deleteDocument(id, idx) {
      this.$modals.show('confirm-controller', {
        method: async () => {
          await this.$api.contracts.deleteAgreement(id);
          this.list.splice(idx, 1);
          this.$modals.close();
        },
      });
    },
  },
};
</script>
